var _defs, _rect, _text, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _polyline, _line, _polyline2, _polyline3, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _line2, _path21, _path22, _polygon2, _path23, _path24, _path25, _path26, _polygon3, _path27, _line3, _line4, _path28, _polygon4, _rect2, _polygon5, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _rect3, _rect4, _path42, _path43, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialmediamarketing6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8c4df;}.cls-2{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-2,.cls-3{fill:#2f2143;}.cls-4{fill:#fdc435;}.cls-5{fill:#f7a9a0;}.cls-6{fill:#fff;}.cls-10,.cls-12,.cls-14,.cls-15,.cls-17,.cls-20,.cls-21,.cls-22,.cls-23,.cls-7,.cls-9{fill:none;stroke-miterlimit:10;}.cls-20,.cls-7{stroke:#1f3242;}.cls-7,.cls-9{stroke-width:0.84px;}.cls-8{fill:#3e4244;}.cls-10,.cls-9{stroke:#3e4244;}.cls-10,.cls-12,.cls-9{stroke-linecap:round;}.cls-10{stroke-width:0.73px;}.cls-11{fill:#9a499c;}.cls-12,.cls-17,.cls-21,.cls-22,.cls-23{stroke:#2f2143;}.cls-12{stroke-width:1.21px;}.cls-13{fill:#1b334f;}.cls-14{stroke:#513735;stroke-width:0.42px;}.cls-15{stroke:#491f1f;stroke-width:0.5px;}.cls-16{fill:#e5ac24;}.cls-17{stroke-width:1.3px;}.cls-18{fill:#1f3242;}.cls-19{fill:#ffc537;}.cls-20,.cls-21{stroke-width:2px;}.cls-22{stroke-width:1.8px;}.cls-23{stroke-width:1.12px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SOCIAL MEDIA MARKETING 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1600,
    height: 326
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(563.75 156.24)"
  }, "SOCIAL MEDIA ", /*#__PURE__*/React.createElement("tspan", {
    x: 58.07,
    y: 75
  }, "MARKETING"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "297.93 325.7 299.01 265.66 303.57 265.66 318.25 325.7 362.64 325.7 345.58 213.58 245.64 213.58 255.45 325.68 297.93 325.7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M271.05,55.42l2.79-14.33a17.27,17.27,0,0,0-12.7-5.82c-8.75.06-13.55,7.17-13.92,7.73a20.21,20.21,0,0,0,2.22,26.06s4.1,7.2,2.63,14.24A24.43,24.43,0,0,1,248,90.83s-6.6,4.87-3.51,10.07H275.9a5.57,5.57,0,0,1-2.5-5.47s2.32-7.72,1.2-12.45a26.18,26.18,0,0,0-4.31-12.44s-9.5-15.24.76-15.12",
    transform: "translate(0 -0.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M306.37,94.4s14.44,3.44,20.78,11.65c0,0,15.63,16.34,17.35,27.93l9.92,18.43-5.83,59.11,4.21,15.36-18.24.42s-7.93-.59-7.58-10.88,2.25-66.3,2.25-66.3.18-8.11-2.43-13.65S306.37,94.4,306.37,94.4",
    transform: "translate(0 -0.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.64,57.28s-.78-12.72-5.52-15.67c0,0-9,12.91-21.8,13.31a30.63,30.63,0,0,1-.51,8.71l-16.28,3.3s-5.33-8.42-3.8-16.51c0,0,1.82-12.39,13.08-16.45,0,0,14.36-6.88,28.73,4.38,0,0,9.83-1.9,10.76,9.21a12.17,12.17,0,0,1-4.66,9.72",
    transform: "translate(0 -0.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M312.75,128.09,282.49,98.65l1.88-20.31s-9.44.82-10.87-9.33c0,0-.27-5.31,3.16-7.68,0,0,6.56-5.45,12.92,3.5,0,0,.73-7.54.6-9.18,0,0,10.17,1.16,21.8-13.31,0,0,6.3,3.52,5.54,20.6,0,0,3.1,6.16,2,10.93,0,0-1.07,9.36-11.71,11.17Z",
    transform: "translate(0 -0.3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.65,97.11l28.9,28.11-2.86-30.08s21.7,41,22.28,48.37l-2.47,68.74H305.1Z",
    transform: "translate(0 -0.3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.8,97.12s-25.74,6.55-31.87,12.31-31,42.32-48.2,79.38c0,0-9.94,26.64,22.8,38.82a31.09,31.09,0,0,0,19.74-2l2.19-1.1,18.5,3.07,30.44,1.84s11.64-1.67,8.84-17.2l-.78-47.87s-2.91-22.29-21.66-67.28",
    transform: "translate(0 -0.3)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "246.56 225.24 273.51 210 255.86 176.03 218.61 187.26"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 246.06,
    y1: 178.02,
    x2: 259.56,
    y2: 156.47
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "282.08 102.75 276.99 123.5 289.19 137.11 287.01 148.1 300.96 165.46"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "316.97 102.75 333.2 121.31 333.2 137.11 340.61 146.26 335.38 156.47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M303.72,60.3l0,.16a2.85,2.85,0,0,0-.07-.64c-.34-1.26-1.34-2.08-2.25-1.84a1.49,1.49,0,0,0-.93.91v-.17s-.74,1.77-2.38.39c0,0,.19,2.22,2.22,1.39l0-.14a2.09,2.09,0,0,0,0,.34c.34,1.26,1.34,2.09,2.24,1.84a1.54,1.54,0,0,0,1-1.16v.11a2.29,2.29,0,0,1-.72,1.56s.33.12.79-.78a3.49,3.49,0,0,0,0-2",
    transform: "translate(0 -0.3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M311.33,59.71v.16a3.51,3.51,0,0,1,.08-.63c.33-1.26,1.34-2.08,2.24-1.84a1.46,1.46,0,0,1,.94.91l0-.18s.75,1.78,2.39.39c0,0-.19,2.22-2.23,1.4v-.15c0,.12,0,.23,0,.35-.34,1.26-1.34,2.08-2.25,1.84a1.55,1.55,0,0,1-1-1.16v.11a2.29,2.29,0,0,0,.72,1.56s-.33.12-.8-.78a3.47,3.47,0,0,1,0-2",
    transform: "translate(0 -0.3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M307.92,60.89c-.07,1.45-.16,2.89-.29,4.33l-.29-.2a3.46,3.46,0,0,1,1.45-.33c1.81-.11,2.1,2.11,1.74,3.4.11-2.1-.68-3.74-3-2.71l-.33.14a33,33,0,0,1,.73-4.63",
    transform: "translate(0 -0.3)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M298.66,69.86a15.37,15.37,0,0,0,11.92,2.71c-4,1.54-8.81.14-11.92-2.71",
    transform: "translate(0 -0.3)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M297.38,71.45A2.23,2.23,0,0,1,299.83,69a3.74,3.74,0,0,0-2.45,2.47",
    transform: "translate(0 -0.3)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M296.64,54.49s5.18-2.94,8.66,0",
    transform: "translate(0 -0.3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M309.78,54.49s3.94-2.94,6.6,0",
    transform: "translate(0 -0.3)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M277,64.22s7.89-7.43,10.67,4.79",
    transform: "translate(0 -0.3)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M272,149c-8.75,3.28-22.35,12.59-27.63-.71-4.84-12.75,11.14-15.59,19.3-19.38Z",
    transform: "translate(0 -0.3)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292,129c12.41,29.31,31.14,21.54,19.18-7.95C298.81,91.7,280.08,99.47,292,129",
    transform: "translate(0 -0.3)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M310.27,147.59,272,149,263.66,129l28.08-26.06c-4.77,13.9,3.64,37.26,18.53,44.7",
    transform: "translate(0 -0.3)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M263.66,129S257.93,138.24,272,149",
    transform: "translate(0 -0.3)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.38,154.68s17.16,18.15,14.85,30.32l12.46-5.16s-12.82-12.76-15.52-30.05Z",
    transform: "translate(0 -0.3)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M334.35,99.27c8.36.92,17.63,13.92,9,24.5",
    transform: "translate(0 -0.3)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M337.19,92.53c11,1.21,23.2,18.33,11.88,32.25",
    transform: "translate(0 -0.3)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M339.2,84.55c14.44,1.58,30.47,24.06,15.61,42.34",
    transform: "translate(0 -0.3)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 282.33,
    y1: 61.82,
    x2: 282.08,
    y2: 66.65
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M255.87,176.16l1.58-.48s3.89-10,4.15-10.36,3.1-4.4,6.55-4.88l5.94-1.87a8.35,8.35,0,0,1,4.11.52s4.19,1.33,2.2,4.55l2.62,8.61s.74,6.12-6.14,5.19c0,0-4.6,5.52-10.8,4.83l-2.45,2.5Z",
    transform: "translate(0 -0.3)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M291.25,80s3.12,5,15.13,4.47",
    transform: "translate(0 -0.3)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "260.41 188.12 255.2 175.94 256.42 175.68 264.17 184.29 260.41 188.12"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M272.19,163.3s6-3.45,8.21.34",
    transform: "translate(0 -0.3)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M272.89,166.62s6-3.45,8.21.34",
    transform: "translate(0 -0.3)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M274.06,169.94s6-3.45,8.21.35",
    transform: "translate(0 -0.3)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M274.84,172.8s6-3.46,8.2.34",
    transform: "translate(0 -0.3)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "325.06 210.52 371.64 210.52 405.28 140.85 358.71 140.85 325.06 210.52"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.74,188.32s2.45-5.17,1.42-8.28-3.78-10.63-3.78-10.63,2.66-8.74,9.73-7.15c0,0,2.5.23,5.77,8l-1.31-12.64s1.55-5.35,4.1-.37l1.17,15.36a5.56,5.56,0,0,1-3.23,4.69s-7.07,11.54-13.87,11",
    transform: "translate(0 -0.3)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 383.32,
    y1: 167.72,
    x2: 387.68,
    y2: 176.87
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 385.5,
    y1: 164.45,
    x2: 391.71,
    y2: 173.6
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M471.87,258.43l-26.72,16.7a8.93,8.93,0,0,1-12.27-2.84L425.2,260A8.94,8.94,0,0,1,428,247.74L454.76,231A8.94,8.94,0,0,1,467,233.87l7.67,12.29a8.93,8.93,0,0,1-2.83,12.27",
    transform: "translate(0 -0.3)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "444.25 256 440.25 249.6 447.8 249.34 455.34 249.07 451.8 255.74 448.25 262.41 444.25 256"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1438.76,
    y: 53.31,
    width: 58.5,
    height: 36.44,
    transform: "translate(-1.41 102.37) rotate(-4)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1437.56 55.1 1468.01 71.23 1495.91 51.02 1437.56 55.1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1550.3,247.11A39.33,39.33,0,1,1,1511,207.79,39.31,39.31,0,0,1,1550.3,247.11Z",
    transform: "translate(0 -0.3)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1494.48,282.8c-23.83-35.85,0-71.38,0-71.38",
    transform: "translate(0 -0.3)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1527.4,211.42s23.83,35.53,0,71.38",
    transform: "translate(0 -0.3)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1507.47,208.87s-24.6,42.2,0,76.79",
    transform: "translate(0 -0.3)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1514.79,208.87s24.6,42,0,76.64",
    transform: "translate(0 -0.3)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1543.87,225.55c-28.41,20.4-66.66,1.42-66.66,1.42l-5.54,16.7s41.49,20.79,78.48,0Z",
    transform: "translate(0 -0.3)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1477.21,267.24s33.09,16.25,67.55,0",
    transform: "translate(0 -0.3)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1492.79,212.25s22.7,7.75,36.87,0",
    transform: "translate(0 -0.3)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1480.64,232.75c1.1.3,2.2.59,3.3.85.3,2.74.65,5.47,1.07,8.21,1.59-2.3,3.12-4.63,4.57-7,.69.13,1.37.26,2.05.37q.8,4,1.79,8.05c1.35-2.38,2.63-4.79,3.86-7.22,1.13.14,2.26.26,3.38.36q-3.12,6.56-6.82,13l-2.43-.36c-.69-2.72-1.31-5.46-1.86-8.19-1.51,2.36-3.08,4.7-4.72,7-.79-.16-1.58-.34-2.37-.52q-1.2-7.26-1.82-14.51",
    transform: "translate(0 -0.3)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1501.1,236.42c1.12.1,2.24.18,3.37.24q1.15,4,2.5,7.89c1.14-2.55,2.22-5.12,3.24-7.69h2.07c1,2.55,2.06,5.08,3.18,7.6q1.35-3.89,2.51-7.8,1.69-.09,3.39-.24-1.9,7-4.41,14c-.81,0-1.63.07-2.44.09q-1.74-3.84-3.28-7.73c-1.06,2.59-2.19,5.16-3.38,7.73l-2.42-.09q-2.46-6.93-4.33-14",
    transform: "translate(0 -0.3)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1521.79,236.38c1.12-.1,2.24-.22,3.37-.36,1.22,2.46,2.51,4.89,3.86,7.31.68-2.71,1.29-5.43,1.83-8.14l2-.37c1.44,2.33,2.95,4.63,4.51,6.91q.64-4.06,1.09-8.12c1.11-.27,2.22-.55,3.32-.86q-.64,7.25-1.88,14.53c-.8.18-1.6.36-2.41.52q-2.4-3.47-4.62-7-.87,4.11-2,8.21l-2.4.35q-3.66-6.39-6.76-13",
    transform: "translate(0 -0.3)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1250.08,278l-16.21,9.2c-.2.07-.41.12-.61.21-1,.48-2.07,1-3.13,1.45a61.28,61.28,0,0,1-11.93,3.62c-.43.08-.6-.08-.79-.41q-7.9-13.95-15.83-27.89a.93.93,0,0,1-.06-.95,48.85,48.85,0,0,0,2.87-8.66,19,19,0,0,0,.34-7.25c-.52-3.09-1-6.2-1.4-9.31a8.46,8.46,0,0,1,.07-2.75c.81-4,5.88-5.51,8.56-2.81a17.83,17.83,0,0,1,2.27,2.8A50.36,50.36,0,0,1,1219,246c.33,1,.64,1.9,1,2.92l.69-.39c3.59-2,7.18-4.1,10.79-6.12a6.4,6.4,0,0,1,9.54,3.78,16,16,0,0,1,.31,2.19c2.21.41,3,.76,4.13,1.77.28.26.54.53.81.8l.78,1.37a20.35,20.35,0,0,1,.36,3.08,12.71,12.71,0,0,1-.62,2.62,6.34,6.34,0,0,1,3.25,4,6.4,6.4,0,0,1-.88,5.27l.39.25a6.35,6.35,0,0,1,2.45,7.7,8.17,8.17,0,0,1-1.91,2.73",
    transform: "translate(0 -0.3)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1199,267.05l15.1,26.59c-.19.12-.35.24-.52.33l-8.74,5a1.93,1.93,0,0,1-3-.84q-6.48-11.38-12.94-22.78a1.89,1.89,0,0,1,.81-3l8.79-5,.52-.3",
    transform: "translate(0 -0.3)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1180.15,
    y: 60.2,
    width: 48.27,
    height: 48.27,
    rx: 9.07,
    transform: "translate(95.58 561.75) rotate(-27.32)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1188.16,
    y: 68.22,
    width: 32.24,
    height: 32.24,
    rx: 9.07,
    transform: "translate(95.58 561.75) rotate(-27.32)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1209.48,81.66a5.85,5.85,0,1,1-7.88-2.52A5.85,5.85,0,0,1,1209.48,81.66Z",
    transform: "translate(0 -0.3)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1210.72,70.31a2.53,2.53,0,1,1-3.4-1.08,2.53,2.53,0,0,1,3.4,1.08",
    transform: "translate(0 -0.3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 1363.44,
    cy: 160.55,
    r: 24.82
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 507.37,
    cy: 61.68,
    r: 22.36
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 119.64,
    cy: 269.64,
    r: 13.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmediamarketing6);
export default __webpack_public_path__ + "static/media/SOCIAL MEDIA MARKETING 6.2cb9d0a335b703dcf19e25fb5af2961f.svg";
export { ForwardRef as ReactComponent };